const messages = (state: any = [], action: any) => {
  switch (action.type) {
    case 'PUSH_MESSAGE':
      return [
        ...state,
        {
          text: action.text,
          variant: action.variant
        }
      ];
    case 'SHIFT_MESSAGE':
      return state.slice(1, state.length);
    default:
      return state;
  }
};

export default messages;
